export const SANITARI_QUALS = ["Medico", "Infermiere"];
export const volunteerQuals = (list) => (list || []).filter((q) => !SANITARI_QUALS.includes(q));
